import React, {useEffect} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import * as api from "../../services/api";

import {LoadingOverlay} from "../../components/LoadingOverlay";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";


const UnlockAccountPage = () => {
    let navigate = useNavigate();
    const [isLoading, setIsLoading] = React.useState(true);
    const [error, setError] = React.useState(false);
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    useEffect(() => {
        const unlock = async () => {
            if (token) {
                try {
                    await api.Authentication.unlockAccount(token);
                } catch {
                    setError(true);
                }
            } else {
                setError(true);
            }
            setIsLoading(false);
        };

        unlock();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const handleClickHomepage = (e) => {
        e.preventDefault();
        navigate("/")
    };

    return (
        <Box sx={{
            mt: 1,
            position: "relative",
            width: "100%",
            height: 200,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <LoadingOverlay isLoading={isLoading} transparent>
                {
                    error ? (
                        <Typography component="div" variant="body1">
                            <Box sx={{color: 'error.main'}}>
                                Impossibile sbloccare l'account
                            </Box>
                        </Typography>
                    ) : (
                        <React.Fragment>
                            <Typography component="div" variant="body1">
                                Il tuo account è stato sbloccato
                            </Typography>
                            <Button fullWidth
                                    variant="contained"
                                    sx={{mt: 5, mb: 2}}
                                    onClick={handleClickHomepage}>
                                Homepage
                            </Button>
                        </React.Fragment>
                    )
                }
            </LoadingOverlay>
        </Box>
    );
};

export default UnlockAccountPage;